angular.module('app.shared.clipSearch.clipFilterService', [])
  .factory('app.shared.clipSearch.clipFilterService', [
    '$http',
    ($http) => {
      "use strict";

      return {
        getFilterLabels: filters => {
          return $http.post(window.location.api('clips_filters/convert_to_labels'), filters);
        },
        createFilter: (name, filters) => {
          return $http.post(window.location.api('clips_filters/user'), {name: name, filters: filters});
        },
        updateFilter: filter => {
          return $http.put(window.location.api(`clips_filters/user/${filter.id}`), filter);
        },
        deleteFilter: filterId => {
          return $http.delete(window.location.api(`clips_filters/user/${filterId}`));
        }
      }
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/clipSearch/clipFilterService.js